<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <PrimaryButton
          x-small
          @click="editItem"
          btnClass="mr-2 rounded"
          icon="mdi-pencil"
          iconClass=""
          v-on="on"
          v-bind="attrs"
        >
        </PrimaryButton>
      </template>
      <span>Edit</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    editItem() {
      this.$router.push({
        name: "edit-account-admin",
        params: { id: this.params.data.id },
      });
    },
  },
};
</script>

<style></style>
